(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ssp-entiat-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ssp-entiat-gallery')) customElements.define('ssp-entiat-gallery', class extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    const variants = JSON.parse(this.querySelector('[data-variants]').textContent);
    const groups = [...this.querySelectorAll('[data-photo-group]')];
    const showVariant = variant => {
      if (!variant) return;
      groups.forEach(group => {
        const show = group.dataset.frame === variant.option1 && group.dataset.lens === variant.option2;
        if (!group.hidden && !show) group.querySelectorAll('video').forEach(video => video.pause());
        group.hidden = !show;
      });
    };
    this.setActiveMedia = showVariant;
    this.unsubscribe = window.MinimogEvents?.subscribe(`${this.dataset.productId}__VARIANT_CHANGE`, showVariant);
    const form = this.closest('.sf-product-wrapper')?.querySelector('.main-product-form');
    form?.addEventListener('change', () => requestAnimationFrame(() => showVariant(variants.find(v => String(v.id) === form.querySelector('[name="id"]')?.value))));
    const dialog = this.querySelector('dialog');
    const zoomImage = dialog.querySelector('img');
    this.addEventListener('click', event => {
      const photo = event.target.closest('[data-photo-src]');
      if (photo) {
        zoomImage.src = photo.dataset.photoSrc;
        zoomImage.alt = photo.querySelector('img').alt;
        dialog.showModal();
      }
      if (event.target.closest('[data-ssp-close]') || event.target === dialog) dialog.close();
      const direction = event.target.closest('[data-photo-direction]');
      if (direction) {
        const track = this.querySelector('[data-photo-group]:not([hidden]) .ssp-entiat-photos');
        track?.scrollBy({left:track.clientWidth * Number(direction.dataset.photoDirection),behavior:'smooth'});
      }
    });
  }
  disconnectedCallback() { this.unsubscribe?.(); }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ssp-purchase-points"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ssp-policy-summary')) customElements.define('ssp-policy-summary', class extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    const dialog = this.querySelector('dialog');
    this.querySelector('.ssp-policy-trigger').addEventListener('click', () => dialog.showModal());
    this.querySelector('[data-ssp-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  }
});
  } catch(e) { console.error(e); }
})();

})();
